import { createContext } from 'react';

const AppContext = createContext<{
  routes?: {
    path: string;
    element: React.ReactNode;
  }[];
  isCompleteOnboarding?: boolean;
}>({});

export default AppContext;
